
export const makeRowId = () => 
    `row_${Date.now().toString(36)}_${Math.random().toString(36).slice(2)}`;



export const getYearsRange = () => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let i = -10; i <= 10; i++) {
        years.push(currentYear + i);
    }
    return years;
};

export const getQuarterOptions = (): string[ ]=> {
    const currentYear = new Date().getFullYear();
    const start = currentYear - 1;
    const end = currentYear;

    const quarters = ["Q1", "Q2", "Q3", "Q4"];
    const options: string[] = [];

    for (let year =start; year<= end;year++){
        for(const quarter of quarters){
            options.push(`${year} ${quarter}`);
        }
    }
    
    return options;
};


export const formatDateString = (val?: string | null | Date) => {
    if(!val) return "";

    if(typeof val === "string") {
        return val;
    }

    if (val instanceof Date && !isNaN(val.getTime())) {
        return val.toISOString().split("T")[0];
    }

    return "";
};

